// Centralized spring + tween configs for the Studio motion system.
//
// Plan ref: 06-01-PLAN-motion-primitives-view-transitions.md §Task 1
// Research: 06-RESEARCH-motion-responsive-a11y.md §Pattern 1 + §11
// REQ:      UI-MOTION-02 (Linear-feel spring)
//
// Linear-feel was confirmed by visual A/B against linear.app interactions.
// Per-component overrides (e.g., TraceTree, ChartCardDrill) are documented
// in studio/docs/design/motion.md — reach for those only when the canonical
// role does not fit the surface area being morphed.

import type { Transition } from 'motion/react';

/** Linear-feel default — used by Reveal hand-off + Feedback role. */
export const LINEAR_SPRING: Transition = {
  type: 'spring',
  stiffness: 280,
  damping: 32,
  mass: 0.8,
};

/** Snappier spring for tight affordance / tap interactions. */
export const FAST_SPRING: Transition = {
  type: 'spring',
  stiffness: 400,
  damping: 36,
  mass: 0.7,
};

/**
 * Reduced-motion fallback. When prefers-reduced-motion: reduce, every motion
 * variant collapses to this 80ms linear tween — well below the AC-6 budget.
 */
export const REDUCED_TRANSITION: Transition = {
  type: 'tween',
  duration: 0.08,
  ease: 'linear',
};
